import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { tr } from 'i18n';
import { isSingleLoadClick } from 'pages/ReportCard/utils/rowInteraction';
import './LoadRowToggle.scss';

type Props = {
  item: { id: number; vehicle_number?: string };
  expanded: boolean;
  sequence: number;
  controls: string;
  onToggle: (id: number) => void;
  className?: string;
};

export default function LoadRowToggle({ item, expanded, sequence, controls, onToggle, className }: Props) {
  useTranslation();
  return <button
    type="button"
    className={`loadRowToggle ${className || ''}`}
    aria-label={tr('Подробнее о перевозке {{value0}}', { value0: item.vehicle_number || item.id })}
    aria-expanded={expanded}
    aria-controls={controls}
    onClick={event => { event.stopPropagation(); if (isSingleLoadClick(event)) onToggle(item.id); }}
  >
    {expanded ? <ChevronDown size={14} aria-hidden="true" /> : <ChevronRight size={14} aria-hidden="true" />}{tr(sequence)}
  </button>;
}
